module.exports = __webpack_public_path__ + "static/media/pre-defined-map-packs.a733fcd7.png";